<template>
    <div>
        Add a fee of {{amount | number({minimumFractionDigits: 2})}} to the customer's next invoice.
    </div>
</template>

<script>
    import BaseActionSummary from '../base-action-summary';

    export default {
        name: 'add-nsf-fee-summary',
        extends: BaseActionSummary,
    };
</script>
